import { Header, Wrapper, StyledTable, TableHeader, TableCell, TableRow, Info } from "../styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { useTranslation } from "react-i18next";
import { PRICE_TABLES } from "./priceTable.config";

const PriceTable = ({ variant }) => {
    const { t } = useTranslation("priceList");

    const cfg = PRICE_TABLES[variant];
    if (!cfg) return null;

    const columns = cfg.columns;
    const rows = cfg.rows;
    const IconMap = cfg.icons;
    const typeLabelKey = cfg.typeLabelKey ?? "common.columns.type";

    return (
        <Wrapper id={cfg.wrapperId}>
            <StaggeredContainer>
                <StaggeredItem>
                    <Header>{t(cfg.titleKey)}</Header>
                </StaggeredItem>

                <StaggeredItem>
                    <StyledTable>
                        <thead>
                            <TableRow>
                                <TableHeader />
                                <TableHeader />
                                {columns.map((col) => (
                                    <TableHeader key={col.key}>{t(col.labelKey)}</TableHeader>
                                ))}
                            </TableRow>
                        </thead>

                        <tbody>
                            {rows.map((row) => {
                                const Icon = IconMap[row.icon];

                                return (
                                    <TableRow key={row.key}>
                                        <TableCell data-kind="type" data-label={t(typeLabelKey)}>
                                            <span className="cellValue">{t(`${variant}.rows.${row.key}`)}</span>
                                        </TableCell>
                                        <TableCell data-kind="icon" data-label={t("common.columns.icon")}>
                                            {Icon ? <Icon /> : null}
                                        </TableCell>
                                        {row.values.map((val, idx) => (
                                            <TableCell
                                                key={`${row.key}-${columns[idx].key}`}
                                                data-kind="value"
                                                data-col={columns[idx].key}
                                                data-empty={val === "-" ? "true" : "false"}
                                                data-label={t(columns[idx].labelKey)}
                                            >
                                                <span className="cellValue">{val}</span>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </tbody>
                    </StyledTable>
                </StaggeredItem>

                {cfg.notes?.linesKeys?.length ? (
                    <StaggeredItem>
                        <Info>
                            {cfg.notes.linesKeys.map((k, i) => {
                                const line = t(k);
                                const isStrong = i === cfg.notes.strongLineIndex;

                                return (
                                    <span key={k}>
                                        {isStrong ? <strong>{line}</strong> : line}
                                        <br />
                                    </span>
                                );
                            })}
                        </Info>
                    </StaggeredItem>
                ) : null}
            </StaggeredContainer>
        </Wrapper>
    );
};

export default PriceTable;